





























import { Component, Vue, Prop } from "vue-property-decorator";
import { pageDataType } from "../types";
import { HOST } from "../global";
import { TimelineMax, TweenLite, TweenMax, Power2, Power3, Power1 } from "gsap";

@Component({
  name: "VideoCard",
})
export default class VideoCard extends Vue {
  @Prop() readonly compData!: any;
  public HOST: string = HOST;
  public videoId: any = (this as any).compData.video_id;
  public host: any = 'https://www.youtube.com/embed/' + this.videoId + '?showinfo=0&enablejsapi=1&origin=http://localhost:8080';
   data() {
    return {
      playerVars: {
        autoplay: 1,
        fitparent: true,
        frameborder: 0,
        loop: 1,
        controls: 0,
        mute: 1,
        modestbranding: 1,
        showinfo: 0,
        rel: 0,
        disablekb: 1,
        playsinline: 1,
        iv_load_policy: 3,
        allowfullscreen: "true"
      }
    }
  }
 videoAnim() {
  var imganim = new TimelineMax({
  //  delay: 4.5
  });
   imganim
   .from(
        ".video-wrap",
        1.2,
        {
          autoAlpha: 0,
          yPercent: -40,
          ease: Power2.easeInOut,
          clearProps: "all",
        },
        0.1
      )
      
  }
  
    ended () {
      (this as any).$refs.youtube.player.playVideo();
    }

    player() {
        return (this as any).$refs.youtube.player;
    }
mounted () {
    this.videoAnim();
}



}
